import type { SummarizeStore } from './interfaces'

export const createInitialState = (): SummarizeStore => ({
  show: false,
  bookingId: null,
  summaryId: null,
  duration: null,
  speakingTime: null,
  lessonDate: null,
  summary: null,
  recordingUrl: null,
  topic: null,
  highlights: [],
  homeActivities: [],
  homeTasks: [],
  activeId: null,
  status: 'idle',
  requestId: 0,
  rating: null,
  comment: null,
  survey: false,
  title: null,
  bannerFeedback: false,
  seekTime: null,
})
